import { create } from 'zustand';
import api from '@/utils/api';
import { CollectionType } from '@/lib/types';

interface ContentTypesStore {
  collectionTypes: CollectionType[];
  showAlert: boolean;
  error: string | null;
  loadCollectionTypes: (workspaceId: string) => Promise<void>;
}

const useCollectionTypeStore = create<ContentTypesStore>()((set) => ({
  collectionTypes: [],
  showAlert: false,
  error: null,
  loadCollectionTypes: async (workspaceId: string) => {
    try {
      set({ showAlert: false, error: null });
      const response = await api.get(`collection-types/workspace/${workspaceId}`);
      const types = (response.data as CollectionType[]).sort((a, b) =>
        a.name.localeCompare(b.name),
      );

      set({
        collectionTypes: types,
        showAlert: types.length === 0 ? true : false,
      });
    } catch (error: any) {
      set({
        error: error.response?.data?.error || 'Failed to load content collections',
        showAlert: false,
      });
    }
  },
}));

export default useCollectionTypeStore;
